module.exports = __webpack_public_path__ + "static/img/price_pocily.8c1c1ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/price_pocily.svg
// module id = xEHz
// module chunks = 1